/* Donestate fixes (Oct 2026). Small behaviour fixes on top of theme.js. */

/* Cart: clearing the quantity box used to remove the item. Put the old number back instead. */
document.addEventListener('change', (event) => {
  const input = event.target;
  if (!input.closest || !input.closest('ds-cart-items ds-quantity-input[data-line]')) return;
  if (input.value === '' || Number(input.value) < 0) {
    event.stopImmediatePropagation();
    input.value = input.defaultValue || 1;
  }
}, true);

/* Entry screen: pressing Back after choosing a link brought the full-screen menu back. */
window.addEventListener('pageshow', (event) => {
  if (!event.persisted) return;
  const screen = document.querySelector('ds-entry-screen');
  if (!screen || screen.hidden || screen.dataset.frequency === 'always') return;
  screen.release?.();
  if (screen.onKeyup) document.removeEventListener('keyup', screen.onKeyup);
  document.documentElement.classList.remove('entry-screen-open');
  screen.hidden = true;
});

/* "What's my fit?" pop-up: on smaller screens the size result appeared below the visible part. Scroll it into view. */
document.querySelectorAll('.fit-finder [data-out], [data-fit-finder] [data-out]').forEach((out) => {
  new MutationObserver(() => {
    if (out.firstElementChild) out.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }).observe(out, { childList: true });
});
